import script from "./best-ways-to-calculate-commodity-price-risks-understanding-the-main-risks-involved.vue?vue&type=script&setup=true&lang=js"
export * from "./best-ways-to-calculate-commodity-price-risks-understanding-the-main-risks-involved.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__